import React, { useState, useEffect} from "react";
import { FlexContainer, Page, StyledHeader, HeaderBorder, HeaderOverlay, GradientText} from "../components/styled";
import styled from "styled-components";
import PreSaleBadge from "../assets/images/presalebadge.png";
import SloganBadge from "../assets/images/sloganBadge.png";
import { countDownFinishDate } from "../constants";
 import { useUserContext } from "../context/UserContext";
import InviteIcon from "../assets/icons/invite.svg";
import GitbookIcon from "../assets/icons/gitbook.svg";
import TwitterIcon from "../assets/icons/twitter.svg";
import TelegramIcon from "../assets/icons/telegram.svg";
import { useBottomSheet } from "../context/BottomSheetContext";
import InviteModalContent from "../components/inviteModalContent";
import { Link } from "react-router-dom";
import {hearthbeat} from "../components/styled/animations";

const CustomHeader = styled(StyledHeader)`
    background: linear-gradient(90deg, #635DC2 0%, #9090FB 42%, #635DC2 100%);
    top: -8px;
`;
const HeaderText = styled(GradientText)`
    font-size: 1.8em;
    font-weight: 700;
`;
const Badge = styled.img`
    position: fixed;
    right: 0;
    top: 17vh;
    z-index: 10;
    animation: ${hearthbeat} 1.5s ease-in-out infinite both;
    @media (min-width: 420px) {
        right:calc((100vw - 420px) / 2)
    }
`;
const Title = styled.h2`
    font-size: 3em;
    font-weight: 700;
    color: ${(props) => props.theme.colors.text.light};
    margin: 0;
    margin-bottom: 3%; 
    text-shadow: 8px 8px 24px rgba(255, 255, 255, 0.34);
`;
const ContentContainer = styled(FlexContainer)`
    flex:1;
    flex-direction: column;
    justify-content: flex-start;
    z-index: 1;
    padding: 0 2%;
`;
const CountDownContainer = styled(FlexContainer)`
    flex-direction: column;
    margin-top: 17%;
    gap:10px;
`;
const CountDownItemContainer = styled(FlexContainer)`
   /* width: 25%; */
   border-radius: 12%;
   height: auto;
   width: 100%;
   min-width: 100%;
   /* aspect-ratio:1/1.3; */
   background: linear-gradient(111.93deg, rgba(33, 50, 96, 0.3) 35.65%, rgba(74, 105, 177, 0.3) 68.27%, rgba(29, 48, 85, 0.3) 98.37%);
   align-items: center;
   justify-content: flex-start;
   flex-direction: column;
   gap:0px;
`;
const CountDownInnerContainer = styled(FlexContainer)`
   border-radius: 12%;
   border: 2px solid #FFFFFF;
   width: 100%;
   backdrop-filter: blur(10px);
   box-shadow: 0px 6px 0px 0px #3C5184;
   aspect-ratio:1;
   background: linear-gradient(111.93deg, #213260 35.65%, #4A69B1 68.27%, #1D3055 98.37%);
`;
const CounDownText = styled.h2`
    font-size: 3.5em;
    font-weight: 700;
    @media (max-width: 400px) {
        font-size: 2.5em;
    }
    @media (max-width: 350px) {
        font-size: 1.5em;
    }
`;
const CounDownLabel = styled.h3`
    font-size: 1em;
    font-weight: 500;
    margin: 0;
    margin-top: 12%;
    margin-bottom: 6%;
    transform: translateY(-12%);
    text-transform: uppercase;
    @media (max-width: 350px) {
        font-size: 0.8em;
    }
`;
const SloganContainer = styled(FlexContainer)`
    background: linear-gradient(180deg, #00426A 0%, #46A6E1 100%);
    padding-left: 10%;
    padding-right: 5%;
    aspect-ratio: 1/0.35;
    backdrop-filter: blur(10px);
    box-shadow: 0px 4px 0px 0px #054A73;
    font-size: 1em;
    border-radius: 14px;
    position: relative;
    border: 2px solid #FFFFFF;
    margin-top: 5%;
    box-shadow: 10px 10px 102px -10px rgba(255,255,255,1);
    gap: 5px;
    @media (min-width: 600px) {
        font-size: 1.2em;
    }
    @media (max-width: 375px) {
        font-size: 0.9em;
    }
`;
const SloganBadgeContainer = styled.img`
    position: absolute;
    left: -20px;
    top: -10px;
`;
const Line = styled.div`
    background: linear-gradient(90deg, rgba(44, 137, 203, 0.25) 0%, #77BEE8 100%);
    width: 100%;
    aspect-ratio: 1/0.02;
    position: absolute;
    top: 10px;
    left: 0;
`;
const Line2 = styled.div`
    position: absolute;
    left: 10px;
    top: 0;
    background: linear-gradient(180deg, rgba(44, 137, 203, 0.25) 0%, #77BEE8 100%);
    aspect-ratio: 0.05/1;
    height: 100%;
`;
const CountDownItemsContainer = styled(FlexContainer)`
    display:grid;
    gap: 10px;
    grid-template-columns: ${({ children }) => `repeat(${children.length}, 1fr)`};
`
const CustomCard = styled(FlexContainer)`
    background: linear-gradient(111.93deg, #213260 35.65%, #4A69B1 68.27%, #5DA8FF 98.37%);
    border-radius: 14px;
    width: 100%;
    aspect-ratio: 2/1;
    /* min-height: 60px; */
    height: auto;
    box-shadow: 0px 4px 0px 0px #3C5184;
    border: 2px solid #FFFFFF;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    img{
        width: 2em;
    }
    span{
        font-size: 1.2em;
        font-weight: 400;
        color: #FFFFFF;
    }
`
const SocialCard = styled(CustomCard)`
    aspect-ratio: 1/1.1;
    position: relative;
    span{
        position: absolute;
        bottom: 10%;
        white-space: nowrap;
        font-size: 1em;
        @media (max-width: 380px) {
            font-size: 0.8em;
        }
    }
    img{
        min-width: 64px;
        @media (max-width: 420px) {
            min-width: 44px;
        }
    }
`
const GridContainer = styled.div`
    display: grid;
    grid-template-columns: ${({ children }) => `repeat(${children.length}, 1fr)`};
    gap: 10px;
    width: 100%;   
    overflow: hidden;
    margin-bottom: 5%;
`
const SeconderTitle = styled.h2`
    font-size: 1.2em;
    font-weight: 500;
    margin-bottom: 5%;
    text-transform: uppercase;
    text-align: center;
`

const CountDownItem = ({ value, label }) => {
    return (
        <CountDownItemContainer>
            <CountDownInnerContainer>
                <CounDownText>{value}</CounDownText>
            </CountDownInnerContainer>
            <CounDownLabel>{label}</CounDownLabel>
        </CountDownItemContainer>
    );
};

const ComingSoon = () => {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });
    const { user } = useUserContext();
    const { openSheet } = useBottomSheet();
    const handleCoundDown = (interval) => {
        const now = new Date();
        const distance = new Date(countDownFinishDate) - now;

        if (distance < 0 && interval) {
            clearInterval(interval);
            return;
        }
        if (distance < 0) {
            return
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        setTimeLeft({ days, hours, minutes, seconds });
    };
    const socialData = [
        {
            icon: GitbookIcon,
            link: "https://cryptohunters-organization.gitbook.io/cryptid-hunter",
            alt: "White Paper"
        },
        {
            icon: TwitterIcon,
            link: "https://x.com/CryptoHunter_W",
            alt: "Twitter"
        },
        {
            icon: TelegramIcon,
            link: "https://t.me/cryptohunterm2p",
            alt: "Telegram"
        }
    ];
    useEffect(() => {

        handleCoundDown();
        const interval = setInterval(() => {
            handleCoundDown(interval);
        }, 1000);
        return () => clearInterval(interval);
    }, []);
    return (
        <Page>
            <StyledHeader>
                <CustomHeader>
                    <HeaderBorder style={{ top: 0 }} />
                    <HeaderOverlay />
                    <FlexContainer>
                        <HeaderText>Cryptid Hunter</HeaderText>
                    </FlexContainer>
                </CustomHeader>
            </StyledHeader>
            <Link to="/presale">
            <Badge src={PreSaleBadge} alt="Pre Sale Badge" />
            </Link>
            <ContentContainer flexdirection="column">
                <CountDownContainer>
                    <Title>ONLY LEFT</Title>
                    <CountDownItemsContainer>
                        {timeLeft.days > 0 && <CountDownItem value={timeLeft.days} label="Days" />}
                        <CountDownItem value={timeLeft.hours} label="Hours" />
                        <CountDownItem value={timeLeft.minutes} label="Minutes" />
                        <CountDownItem value={timeLeft.seconds} label="Seconds" />
                    </CountDownItemsContainer>
                </CountDownContainer>
                <SloganContainer flexdirection="column">
                    <SloganBadgeContainer src={SloganBadge} alt="Slogan Badge" />
                    <Line />
                    <Line2 />
                    <span>Refer friends, earn 5% on their purchases,and</span><span>get a free card per referral!</span>
                </SloganContainer>
                <GridContainer style={{ marginTop: "5%" }}>
                    <CustomCard onClick={() => openSheet({content:<InviteModalContent refCode={user?.referralCode} />,title:"EARN NOVA"})}>
                        <img src={InviteIcon} alt="Invite Icon" />
                        <span>Invite</span>
                    </CustomCard>
                    <CustomCard>
                        <span>Your Invites</span>
                        <span>{user?.referrals?.length || 0}</span>
                    </CustomCard>
                </GridContainer>
                <SeconderTitle>Keep With Us</SeconderTitle>
                <GridContainer>
                    {React.Children.toArray(socialData.map((item) => (
                        <SocialCard onClick={() => window.open(item.link, "_blank")}>
                            <img src={item.icon} alt={item.alt} />
                            <span>{item.alt}</span>
                        </SocialCard>
                    ))
                    )}
                </GridContainer>
            </ContentContainer>
        </Page>
    );
};

export default ComingSoon;